/**
 * AP-7 — Signal-Detailfenster (FM-WIN-03).
 *
 * Oeffnet per Doppelklick auf eine Tabellenzeile, solange DBC-Dekodierung
 * greift — je CAN-ID ein eigenes Fenster. Aktualisiert sich live bei jedem
 * passenden Frame (UpdateFrame() im Original).
 */

import { createFloatingPanel, type FloatingPanel } from './filters/FloatingPanel';
import { createDataTable } from './dataTable';
import {
  decodeSignalValue,
  formatDbcId,
  formatSignalDisplay,
  maxSpnDigits,
  signalInfoText,
  type DbcMessageMeta,
} from './signalValue';
import './views.css';

const NO_DATA = '-- no data yet --';

export interface SignalDetailHandle {
  panel: FloatingPanel;
  /** Rohbytes eines Frames dieser CAN-ID. */
  updateFrame: (data: Uint8Array, dlc: number) => void;
  show: () => void;
}

export function createSignalDetail(message: DbcMessageMeta): SignalDetailHandle {
  const panel = createFloatingPanel(
    `${message.name}  (0x${formatDbcId(message.frameId, message.extended)})`,
  );

  const view = document.createElement('div');
  view.className = 'cm-view cm-view--fit';

  const raw = document.createElement('div');
  raw.className = 'cm-view__raw';
  raw.textContent = NO_DATA;

  const table = createDataTable({
    columns: ['Signal', 'Value', 'Unit', 'Description'],
    emptyText: '',
  });
  table.element.classList.add('cm-table-scroll--values');
  const spnDigits = maxSpnDigits(message);
  table.setRows(
    message.signals.map((sig) => [sig.name, '', sig.unit, signalInfoText(sig, spnDigits)]),
  );

  view.append(raw, table.element);
  panel.body.append(view);

  return {
    panel,
    updateFrame(data, dlc) {
      const shown = Math.min(dlc, 8);
      let text = 'Raw: ';
      for (let i = 0; i < shown; i += 1) {
        text += `${(data[i] ?? 0).toString(16).toUpperCase().padStart(2, '0')} `;
      }
      raw.textContent = text;

      message.signals.forEach((sig, row) => {
        table.setCell(row, 1, formatSignalDisplay(sig, decodeSignalValue(sig, data, shown), false));
      });
    },
    show() {
      panel.show();
    },
  };
}
